var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInventory({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 62,
    viewBox: "0 0 72 62",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3824 2H37.1647C42.0075 2 44.4289 2 46.2786 2.94824C47.9057 3.78234 49.2285 5.11327 50.0575 6.75028C51 8.61131 51 11.0475 51 15.92V46.08C51 50.9525 51 53.3887 50.0575 55.2497C49.2285 56.8867 47.9057 58.2177 46.2786 59.0518C44.4289 60 42.0075 60 37.1647 60H18.7176C13.8748 60 11.4534 60 9.60373 59.0518C7.97668 58.2177 6.65385 56.8867 5.82483 55.2497C4.88235 53.3887 4.88235 50.9525 4.88235 46.08V44.05M39.4706 33.9H26.5M39.4706 22.3H29.3824M39.4706 45.5H16.4118M10.6471 25.2V9.25C10.6471 6.84756 12.5828 4.9 14.9706 4.9C17.3584 4.9 19.2941 6.84756 19.2941 9.25V25.2C19.2941 30.0049 15.4227 33.9 10.6471 33.9C5.87142 33.9 2 30.0049 2 25.2V13.6",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/inventory.23eb1649c4704f8b00f460d93efaea80.svg";
export { ForwardRef as ReactComponent };